<pp-advanced-filter-option-select
  class="advancedFilter__option"
  [ppItems]="advancedFilterTextOptions"
  [ppOption]="option"
  (ppOptionChange)="changeFieldCondition($event)"
  ppClass="advancedFilter__option--condition"
/>

@if (
  option === EAdvancedFilterOptions.IS ||
  option === EAdvancedFilterOptions.IS_NOT ||
  option === EAdvancedFilterOptions.CONTAINS ||
  option === EAdvancedFilterOptions.DOES_NOT_CONTAIN
) {
  <pp-advanced-filter-text-input [(ppValue)]="value" (ppValueChange)="changeFieldValue($event)" />
}
